import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { Chip, HelperText, TextInput } from "react-native-paper";
import { OutlinedInput } from "./OutlinedInput";
import { useTranslation } from "react-i18next";

import {Field} from "../../config/companies/config";

interface PickerFieldWrapperProps {
  field: Field;
  value: any;
  onChange: (fieldName: string, newValue: any) => void;
  onPress: () => void;
  errors?: { [key: string]: string };
  displayValue?: string;
  renderChip?: (item: any, index: number) => React.ReactNode;
}

export const PickerFieldWrapper = ({
  field,
  value,
  onChange,
  onPress,
  errors = {},
  displayValue,
  renderChip,
}: PickerFieldWrapperProps) => {
  const { t } = useTranslation();
  const label = t(field.label) + (field.required ? "*" : "");

  if (field.multiselect) {
    return (
      <View>
        <View style={styles.pickerContainer}>
          <View>
            <OutlinedInput
              error={!!errors[field.name]}
              testID="select"
              label={label}
              editable={false}
              right={<TextInput.Icon icon="chevron-down" />}
            />
            <Pressable onPress={onPress} style={styles.pressableOverlay} />
          </View>
          {Array.isArray(value) &&
            value.length > 0 &&
            value.map((item, index) =>
              renderChip ? (
                renderChip(item, index)
              ) : (
                <Chip
                  key={index}
                  onClose={() => {
                    const newValue = value.filter((_, i) => i !== index);
                    onChange(field.name, newValue);
                  }}
                >
                  {typeof item === "string" ? t(item) : item.toString()}
                </Chip>
              ),
            )}
        </View>
        {errors[field.name] && (
          <HelperText type="error">{t(errors[field.name])}</HelperText>
        )}
      </View>
    );
  }

  return (
    <View>
      <OutlinedInput
        error={!!errors[field.name]}
        right={<TextInput.Icon icon="chevron-down" />}
        testID={"select-" + field.name}
        label={label}
        value={displayValue || ""}
        editable={false}
      />
      <Pressable onPress={onPress} style={styles.pressableOverlay} />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  pickerContainer: {
    gap: 10,
  },
  pressableOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
});
